var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperienceZoneMainHall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "routePath",
    d: "M1302.2,291.6 V311.3 H1095.9 V375.4 H994.2 V527.1 H495.1 V558.5 H381.4 V524",
    stroke: "#FFC223",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "routeStart",
    className: "route-marker",
    cx: 1302.2,
    cy: 291.6,
    r: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "routeEnd",
    className: "route-marker end",
    cx: 381.4,
    cy: 524,
    r: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceZoneMainHall);
export default __webpack_public_path__ + "static/media/experience-zone__main-hall.7641e153.svg";
export { ForwardRef as ReactComponent };